import {
  QueryClient,
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'

import { RequestErrorType } from '@core/utils/api-axios-instance'
import { IBriefingSession } from '@core/entities/briefing'
import { briefingKeys, RequestTypes } from '@core/react-query/features/briefing'
import { optimisticallyHandleBriefingSession } from '@core/react-query/features/briefing/helpers'

export const getCollectBriefingSignaturesMutationOptions = (
  queryClient: QueryClient,
  options: Parameters<typeof useCollectBriefingSignatures>[0] = {},
): Parameters<typeof useCollectBriefingSignatures>[0] => {
  return {
    ...(options ?? {}),
    ...briefingKeys.collectSignatures,
    onSuccess: (...args) => {
      const [data] = args

      // Data (e.g. briefing session) is not returned for self-briefing
      if (data) {
        optimisticallyHandleBriefingSession(queryClient, data)
      }

      options?.onSuccess?.(...args)
    },
  }
}

export const useCollectBriefingSignatures = (
  options: UseMutationOptions<
    IBriefingSession,
    RequestErrorType,
    RequestTypes['collectBriefingSignatures']
  > = {},
) => {
  const queryClient = useQueryClient()

  return useMutation(
    getCollectBriefingSignaturesMutationOptions(queryClient, options),
  )
}
